import Headline from "./atoms/headline"

const Access = () => {
    return (
        <div id='access' className='section'>
            <Headline
                title={'Access'}
                subTitle={'アクセス'}
            />
            <div className="route-list">
                <div className="route">
                    <p className="route-title">電車でお越しの方</p>
                    <img src={process.env.PUBLIC_URL + '/images/station-min.jpg'} alt="高坂駅東口からスタジオまでの道のり" />
                    <p className="text">
                        東武東上線高坂駅東口を出て、交番を右手に直進<br />
                        突き当たり右手に当スタジオがあります
                    </p>
                </div>
                <div className="route">
                    <p className="route-title">お車でお越しの方</p>
                    <img src={process.env.PUBLIC_URL + '/images/parking1-min.jpg'} alt="スタジオ敷地内の駐車場" />
                    <p className="text">当スタジオ敷地内に6台分の駐車場完備</p>
                </div>
            </div>
        </div>
    )
}

export default Access
